import { defineComponent as _defineComponent } from 'vue'
import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { validPhoneNumber } from "@/helpers/validation";
  import useVuelidate from "@vuelidate/core";
  import { email, helpers, required } from "@vuelidate/validators";
  import { reactive, computed } from "vue";
  import { FormSummaryType } from "@/enums/FormSummaryType";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSummaryDesignForm',
  props: {
    formType: {}
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const formTitle = computed(() =>
    props.formType === FormSummaryType.FREE_DESIGN
      ? "Download your free home design"
      : "Book a Free Design Consultation"
  );

  const formFields = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  };

  const formData = reactive(Object.assign({}, formFields));
  const rules = {
    firstName: { required },
    lastName: { required },
    email: { required, email },
    phone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
    },
  };

  const v$ = useVuelidate(rules, formData);

  const emit = __emit;

  const handleSubmit = async () => {
    v$.value.$touch();
    const isFormValid = await v$.value.$validate();

    if (!isFormValid) return;

    emit("submit", formData);
  };

const __returned__ = { props, formTitle, formFields, formData, rules, v$, emit, handleSubmit, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get validPhoneNumber() { return validPhoneNumber }, get useVuelidate() { return useVuelidate }, get email() { return email }, get helpers() { return helpers }, get required() { return required }, reactive, computed, get FormSummaryType() { return FormSummaryType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})